<template>
  <Modal id="PersonalPassword" :visible="visible" @cancel="visible = !visible" @ok="send" :title="$t('public.name.reset_password')" >
    <Form ref="member_form" :model="data" layout="vertical" :rules="validateRules">
      <Row :gutter="[16,16]">
        <Col :xs="24" :sm="12">
          <FormItem :label="$t('public.name.password')" name="password">
            <InputPassword :placeholder="$t('public.name.password')" v-model:value="data.password"></InputPassword>
          </FormItem>
        </Col>
      </Row>
    </Form>
  </Modal>
</template>


<script>
import { Modal, Row, Col, Form, Input, message } from "ant-design-vue";
import { ResetPassword } from "@/api/ResetPassword"

export default {
  name: "PersonalPassword",
  components: {
    Modal,
    Row,
    Col,
    Form,
    FormItem: Form.Item,
    Input,
    InputPassword: Input.Password,
  },
  data() {
    return {
      visible: false,
      data: {
        idEmp:null,
        password: "",
      },
      validateRules: {
        password: [
          {
            required: true,
            message: this.$t("employee.validate.required.password"),
            pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
            trigger: "blur",
          },
        ],
        confirmPassword: [
          {
            required: true,
            message: this.$t("employee.validate.required.password"),
            pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    async show(obj) {
      this._resetData();
      this.data.idEmp = obj.idEmp
      this.visible = true;
    },
    // send put
    send() {
      let api = new ResetPassword();
      this.$refs["member_form"]
        .validate()
        .then(() => {
          api
            .post(this.data)
            .then((response) => {
              if (0 == parseInt(response.data.code)) {
                message.success(response.data.msg);
                this.visible = false;
                this.$emit("updateList");
              } else {
                message.error(response.data.msg);
              }
            });
        })
        .catch();
    },
    // reset data
    _resetData() {
      this.data = {
        idEmp:null,
        password: "",
      };
    },
  },
}
</script>

<style lang="less">
</style>